'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TOGGLE_LOVE = exports.TOGGLE_LOVE = 'TOGGLE_LOVE';
var PROOF_ITEM_HOVER = exports.PROOF_ITEM_HOVER = 'PROOF_ITEM_HOVER';
var PROOF_ITEM_SELECT = exports.PROOF_ITEM_SELECT = 'PROOF_ITEM_SELECT';
var PROOF_MODE_CHANGE = exports.PROOF_MODE_CHANGE = 'PROOF_MODE_CHANGE';